var $export = require('./_export');

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: require('./_string-repeat')
});



//////////////////
// WEBPACK FOOTER
// /home/runner/work/onelocal/onelocal/src/my-referral/~/.pnpm/core-js@2.6.12/~/core-js/modules/es6.string.repeat.js
// module id = ../../../../../../core-js@2.6.12/node_modules/core-js/modules/es6.string.repeat.js
// module chunks = 0